import { NavLink } from "react-router";

import { links } from "@/helpers";
import { useDashboardContext } from "@/layouts/dashboard-layout";

interface NavLinksProps {
  isBigSidebar?: boolean;
}

const NavLinks = ({ isBigSidebar = false }: NavLinksProps) => {
  const { toggleSidebar, user } = useDashboardContext();

  return (
    <div className="nav-links">
      {links.map(link => {
        if (user.role !== "admin" && link.path === "admin") return;

        return (
          <NavLink className="nav-link" key={link.path} to={link.path} end onClick={isBigSidebar ? () => {} : toggleSidebar}>
            <span className="icon">{link.icon}</span>
            {link.text}
          </NavLink>
        );
      })}
    </div>
  );
};

export default NavLinks;
